import branchCollectionModelValidator from './branchCollection';

export default branchCollectionModelValidator;
